<div class="d-flex flex-column gap-3">
  <app-polymorphic-control [c]="dateControl" (change)="onDateChange()"></app-polymorphic-control>
  <app-polymorphic-control [c]="expectedControl"></app-polymorphic-control>
</div>
